/**
 * 主入口文件
 * 使用 Navigo 路由系统，支持全局登录守卫
 */

import '@/styles/tailwind.css';
import '@/styles/error.css';
import '@/styles/users.css';
import '@/styles/change-password.css';
import '@/styles/search-entry.css';
import '@/styles/toast.css';
import { initRouter } from '@/utils/router';
import { showFullScreenError, AppError, ErrorType, ErrorSeverity } from '@/utils/error-handler';

/**
 * 应用初始化
 */
async function initApp(): Promise<void> {
  try {
    // 直接初始化路由（乐观加载）
    await initRouter();
  } catch (error) {
    console.error('应用初始化失败:', error);
    showFullScreenError(
      new AppError(
        ErrorType.UNKNOWN_ERROR,
        ErrorSeverity.CRITICAL,
        'Application initialization failed',
        error,
        '应用初始化失败，请刷新页面重试'
      ),
      {
        route: '/',
        action: 'init',
        retryable: true,
        retryFn: () => {
          location.reload();
        }
      }
    );
  }
}

// 启动应用
initApp().catch((error) => {
  console.error('Fatal error:', error);
  const app = document.getElementById('app');
  if (app) {
    app.innerHTML = `
      <div style="display: flex; align-items: center; justify-content: center; height: 100vh; padding: 20px;">
        <div style="text-align: center; color: rgba(255, 255, 255, 0.7);">
          <p style="margin-bottom: 16px;">应用发生严重错误</p>
          <button onclick="location.reload()" style="padding: 10px 20px; background: rgba(255, 255, 255, 0.1); border: 1px solid rgba(255, 255, 255, 0.2); border-radius: 8px; color: #fff; cursor: pointer;">
            刷新页面
          </button>
        </div>
      </div>
    `;
  }
});
